import * as T from '../constants/types';
import { regions } from '../constants/regions';
import { SELECTED_REGION } from '../constants/variables';

const selectedRegion = regions.find(({ id }) => id === +localStorage.getItem(SELECTED_REGION));
// Сегодняшняя дата в локальной таймзоне в формате 'YYYY-MM-DD' (не UTC — иначе вечером
// возможен сдвиг на соседний день).
const todayLocalISO = () => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};
// Вчерашняя дата в локальной таймзоне ('YYYY-MM-DD').
const yesterdayLocalISO = () => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
};
const initialState = {
    isMapLoaded: false,
    isLayersLoaded: false,
    layers: [],
    selectedRegion: selectedRegion || regions[0],
    apiRegions: [],
    selectedHour: 18,
    selectedDate: yesterdayLocalISO(), // слой «Старты по часам» — дата по умолчанию «вчера» (локальная TZ); из метаданных тайла подставляется только как фолбэк
    selectedScrTracksDate: '2026-07-06', // DA-14933 — дата по умолчанию слоя «Треки исполнителей» (текущий тестовый сэмпл)
    scrTracksSelectedShiftId: null, // DA-14933 — выбранная смена (режим «Детали смены»; null = общий вид)
    scrTracksSelectedRole: null, // DA-14933 — роль выбранной смены (для цвета легенды режима деталей)
    scrTracksSelectedName: null, // DA-14933 — ФИО исполнителя выбранной смены (для сводки в панели)
    scrTracksSelectedPeriod: null, // DA-14933 — период выбранной смены «начало — конец»
    scrTracksSelectedRoleLabel: null, // DA-14933 — человекочитаемая роль выбранной смены
    selectedRebalancePeriod: 0, // 0–7: индекс периода (Ночь_1 … Вечер_2)
    selectedRebalanceDate: todayLocalISO(), // дата по умолчанию — сегодня (локальная TZ)
    selectedRebalanceRoles: { sc: true, ranger: true, other: true },
    selectedRebalanceMinCount: 0, // минимальное число перевозок на парковке
    selectedRebalanceDayMode: 'day', // 'period' | 'day'
    isTerrain3DEnabled: false,
    terrainMode: 'off', // 'hillshade', 'Slope', 'aspect', 'composite', 'off'
};

export const map = (state = initialState, { type, payload }) => {
    switch (type) {
        case T.MAP_LOADED:
        case T.MAP_LAYERS_LOADED:
            return { ...state, ...payload };
        case T.SET_LAYERS:
        case T.CHANGE_REGION:
        case T.SET_SELECTED_HOUR:
        case T.SET_SELECTED_DATE:
        case T.SET_SELECTED_DATE_FROM_TILES:
        case T.SET_SCR_TRACKS_DATE:
        case T.SET_SCR_TRACKS_SELECTED_SHIFT:
        case T.SET_SELECTED_REBALANCE_PERIOD:
        case T.SET_SELECTED_REBALANCE_DATE:
        case T.SET_SELECTED_REBALANCE_ROLES:
        case T.SET_SELECTED_REBALANCE_MIN_COUNT:
        case T.SET_SELECTED_REBALANCE_DAY_MODE:
        case T.TOGGLE_TERRAIN_3D:
        case T.SET_TERRAIN_MODE:
            return { ...state, ...payload };
        case T.ADD_USER_GEOJSON_LAYER: {
            // Пользовательские слои живут в собственной группе сайдбара, которая создаётся
            // при первом перетащенном файле и дальше просто пополняется.
            const { groupId, groupLabel, layer } = payload;
            const hasGroup = state.layers.some(group => group.id === groupId);
            const layers = hasGroup
                ? state.layers.map(group => (group.id === groupId
                    ? { ...group, layers: [ ...group.layers, layer ] }
                    : group))
                : [ ...state.layers, { id: groupId, label: groupLabel, layers: [ layer ] }];

            return { ...state, layers };
        }
        case T.SET_REGIONS:
            // При загрузке регионов из API, обновляем выбранный регион, если он есть в API
            const { apiRegions } = payload;
            const savedRegionId = +localStorage.getItem(SELECTED_REGION);
            const apiSelectedRegion = apiRegions.find(({ id }) => id === savedRegionId);
            const newSelectedRegion = apiSelectedRegion || state.selectedRegion;

            return {
                ...state,
                ...payload,
                selectedRegion: newSelectedRegion,
            };
        default:
            return state;
    }
};
